import { AccumulatorDetails } from "../../components/Rest/FetchACB"
import { BoxWrapper, FlexWrapper, GridWrapper } from "../../components/Wrappers/Wrappers"
import { LgFormInput } from "../../components/Form/FormInput"
import { InfoIcon, SignalIcon } from "./icons"
import { SectionHeading } from "./SectionHeading"

export const AcbOsDetails = ({ data }: { data: AccumulatorDetails }) => {
    return (
        <BoxWrapper bg="bg-primary" r="r10" p="p4" className="relative flex-grow" style={{ minWidth: "400px" }}>
            <FlexWrapper className="full-height relative" flexDirection="row" alignItems="start" justifyContent="space-between">
                <BoxWrapper className="full-width" p="p0">
                    <SectionHeading icon={<SignalIcon />} title="Параметры связи" />
                    <br />
                    <GridWrapper>
                        <LgFormInput
                            value={data.sim_card_number ? data.sim_card_number : "Нет данных"}
                            label="Номер сим (GCM_ICCID)"
                            name="sim_card_number"
                            type="text"
                            required={false}
                            valueSetter={() => {}}
                            disabled={true}
                        />
                        <LgFormInput
                            value={data.gsm_imei ? data.gsm_imei : "Нет данных"}
                            label="GSM_IMEI"
                            name="gsm_imei"
                            type="text"
                            required={false}
                            valueSetter={() => {}}
                            disabled={true}
                        />
                    </GridWrapper>
                </BoxWrapper>
                <BoxWrapper className="full-width" p="p0">
                    <SectionHeading icon={<InfoIcon />} title="Информация об устройстве" />
                    <GridWrapper>
                        <LgFormInput
                            value={data.bms_hw_version ? data.bms_hw_version : "Нет данных"}
                            label="Версия HW BMS"
                            name="bms_hw_version"
                            type="text"
                            required={false}
                            valueSetter={() => {}}
                            disabled={true}
                        />
                        <LgFormInput
                            value={data.accumulator_external_remote_control_hw_version ? data.accumulator_external_remote_control_hw_version : "Нет данных"}
                            label="Версия HW внешнего пульта"
                            name="accumulator_external_remote_control_hw_version"
                            type="text"
                            required={false}
                            valueSetter={() => {}}
                            disabled={true}
                        />
                    </GridWrapper>
                </BoxWrapper>
            </FlexWrapper>
        </BoxWrapper>
    )
}
